export const LOCALES: { [key: string]: string } = { en: "English", es: "Español" } as const;

export const NAV_MENU_V3_ENGAGEMENTS = {
    PROVIDER_LOGO_BTN: "nav_menu_v3_provider_logo_btn",
    BILLING_DROPDOWN_BTN: "nav_menu_v3_billing_dropdown_btn",
    UPCOMING_VISITS_BTN: "nav_menu_v3_upcoming_visits_btn",
    PAYMENT_OPTIONS_DROPDOWN_BTN: "nav_menu_v3_payment_options_dropdown_btn",
    FINANCIAL_ASSISTANCE_BTN: "nav_menu_v3_financial_assistance_btn",
    LANGUAGE_DROPDOWN_BTN: "nav_menu_v3_language_dropdown_btn",
    ENGLISH_BTN: "nav_menu_v3_english_btn",
    SPANISH_BTN: "nav_menu_v3_spanish_btn",
    MY_ACCOUNT_DROPDOWN_BTN: "nav_menu_v3_my_account_dropdown_btn",
    ALL_BILLS_BTN: "nav_menu_v3_all_bills_btn",
    STATEMENT_HISTORY_BTN: "nav_menu_v3_statement_history_btn",
    PAYMENT_HISTORY_BTN: "nav_menu_v3_payment_history_btn",
    PAY_TOTAL_BTN: "nav_menu_v3_pay_total_btn",
    PAY_PARTIAL_BTN: "nav_menu_v3_pay_partial_btn",
    PAYMENT_PLAN_BTN: "nav_menu_v3_payment_plan_btn",
    GET_HELP_BTN: "nav_menu_v3_get_help_btn",
    LIVE_CHAT_BTN: "nav_menu_v3_live_chat_btn",
    MY_ACCOUNT_BTN: "nav_menu_v3_my_account_btn",
    ADD_INSURANCE_BTN: "nav_menu_v3_add_insurance_btn",
    ADD_INSURANCE_APPROVAL_BTN: "nav_menu_v3_add_insurance_approval_btn",
    SIGN_IN_BTN: "nav_menu_v3_sign_in_btn",
    SIGN_OUT_BTN: "nav_menu_v3_sign_out_btn",
} as const;

export const localesToEngagementsMap = {
    en: NAV_MENU_V3_ENGAGEMENTS.ENGLISH_BTN,
    es: NAV_MENU_V3_ENGAGEMENTS.SPANISH_BTN,
} as const;
